///
/// EarthBrowser
///
/// Migration v53 to v54: Data dock width; drop the bottom drawer's
/// desktop-only custom width
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

interface BottomDrawerV53 {
	widthMode?: string
	width?: number
	dockWidth?: number
	[key: string]: unknown
}

interface StateV53 {
	userInterface?: {
		bottomDrawer?: BottomDrawerV53
	}
}

/**
 * Migration: v53 to v54
 *
 * Changes:
 * - Adds bottomDrawer.dockWidth (default: 520): the right-side data dock's
 *   panel width. Desktop dataset browsers move from the bottom drawer to
 *   the dock; phones keep the bottom sheet.
 * - Removes bottomDrawer.widthMode / width (the bottom drawer's desktop
 *   custom-width mode, v22). The drawer is phone-only now and always
 *   full width.
 */
export function migrateV53toV54(state: unknown): unknown {
	if (!state) return state

	const newState = { ...(state as StateV53) }
	const drawer = newState.userInterface?.bottomDrawer
	if (newState.userInterface && drawer) {
		const migrated: BottomDrawerV53 = { ...drawer, dockWidth: drawer.dockWidth ?? 520 }
		delete migrated.widthMode
		delete migrated.width
		newState.userInterface = {
			...newState.userInterface,
			bottomDrawer: migrated,
		}
	}

	return newState
}
